import { render, staticRenderFns } from "./SideMenuTitle.vue?vue&type=template&id=07b7c090&scoped=true"
import script from "./SideMenuTitle.vue?vue&type=script&lang=js"
export * from "./SideMenuTitle.vue?vue&type=script&lang=js"
import style0 from "./SideMenuTitle.vue?vue&type=style&index=0&id=07b7c090&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b7c090",
  null
  
)

export default component.exports